export default __webpack_public_path__ + "static/media/staffCard.7581c3e8.svg";